import { buildWhatsappLink } from "@/lib/whatsapp";
import { WhatsappIcon } from "@/components/icons/WhatsappIcon";

/**
 * Botão flutuante de ajuda no canto inferior direito.
 * "Ainda tem dúvida? Fale com nossa equipe" → abre o WhatsApp da equipe.
 */
const MENSAGEM =
  "Olá, preenchi o cadastro de parceiro Allu e tenho uma dúvida.";

export const WhatsappHelp = () => {
  const href = buildWhatsappLink(MENSAGEM);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-50 inline-flex items-center gap-2.5 rounded-full bg-white pl-3 pr-4 py-2.5 shadow-lg ring-1 ring-zinc-200 hover:ring-zinc-300 hover:shadow-xl transition-all"
    >
      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#25D366] text-white shrink-0">
        <WhatsappIcon className="w-5 h-5" />
      </span>
      <span className="hidden sm:flex flex-col leading-tight text-left">
        <span className="text-[11px] text-zinc-500">Ainda tem dúvida?</span>
        <span className="text-[13px] font-semibold text-[#112711]">
          Fale com nossa equipe
        </span>
      </span>
      <span className="sm:hidden text-[13px] font-semibold text-[#112711]">
        Dúvida?
      </span>
    </a>
  );
};
